export enum OrderStatusEnum {
	NEW = 'new',
	PARTIALLY_FILLED = 'partially_filled',
	FILLED = 'filled',
	DONE_FOR_DAY = 'done_for_day',
	CANCELED = 'canceled',
	EXPIRED = 'expired',
	REPLACED = 'replaced',
	PENDING_CANCEL = 'pending_cancel',
	PENDING_REPLACE = 'pending_replace',
	ACCEPTED = 'accepted',
	PENDING_NEW = 'pending_new',
	REJECTED = 'rejected',
	CALCULATED = 'calculated',
	ACCEPTED_FOR_BIDDING = 'accepted_for_bidding',
	STOPPED = 'stopped',
	SUSPENDED = 'suspended',
	HELD = 'held',
}
